import { Main } from '../Main/Main';
import { ErrorMessage } from '../ErrorMessage/ErrorMessage';

export function ErrorPage({ message }: { message?: string }): JSX.Element {
	return (
		<Main>
			<ErrorMessage message={message} />
		</Main>
	);
}
